import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { filterPermittedActionsWithDividers } from '../../../utils/massActions'
import { isUserProfileActionAddNew } from '../../User'

import {
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_ICON,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_PERMISSION,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_TOOLTIP_KEY,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTIONS_BY_STATUS,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ARCHIVED_ACTIONS,
} from './UserProfilePageActionsWidget.constants'
import { UserProfilePageActionsWidgetAddNewButton } from './UserProfilePageActionsWidgetAddNewButton'

function getActionPermission({ action, userData }) {
  const { permissions = EMPTY_OBJECT } = userData

  const hasPermission =
    permissions[USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_PERMISSION[action]]

  return (
    hasPermission &&
    (action !== USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download ||
      userData.directory_id)
  )
}

function getUserProfilePageActionsWidgetActionList(userData) {
  return userData.isArchived
    ? USER_PROFILE_PAGE_ACTIONS_WIDGET_ARCHIVED_ACTIONS
    : USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTIONS_BY_STATUS[userData.status] ||
        EMPTY_LIST
}

export function isUserProfilePageActionsWidgetActionDownload(action) {
  return action === USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download
}

export function getUserProfilePageActionsWidgetItems({
  addNewOptions,
  getActionList = getUserProfilePageActionsWidgetActionList,
  t,
  userData,
  onSelectAddNewOption,
}) {
  if (!userData) {
    return EMPTY_LIST
  }

  const actions = getActionList(userData)

  const items = actions.map(action => {
    if (isUserProfileActionAddNew(action)) {
      return {
        Component: UserProfilePageActionsWidgetAddNewButton,
        options: addNewOptions,
        permission: addNewOptions.length > 0,
        qaName: action,
        tooltip: t(USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_TOOLTIP_KEY[action]),
        value: action,
        onSelectOption: onSelectAddNewOption,
      }
    }

    return {
      beforeIconProps: {
        Icon: USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_ICON[action],
      },
      permission: getActionPermission({ action, userData }),
      qaName: action,
      tooltip: t(USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_TOOLTIP_KEY[action]),
      value: action,
    }
  })

  return filterPermittedActionsWithDividers(items)
}
